export default __webpack_public_path__ + "static/media/icon-colon.fc9a09a5.svg";